import React from "react";
import { useSelector } from "react-redux";
import Billdetail from "./Billdetail";
import Cartitems from "./Cartitems";

function Cart() {
  const items = useSelector((state) => state.cart);
  return (
    <>
      <main className="py-16">
        <div className="container 2xl:px-8 px-2 mx-auto">
          <h2 className="mb-8 text-xl font-bold">Shopping Cart</h2>
          <div className="cartListContainer">
            {items.length === 0 ? (
              <h1 className="font-bold text-xl">Cart is empty</h1>
            ) : (
              items.map((item, i) => <Cartitems item={item} key={i} />)
            )}
            <Billdetail />
          </div>
        </div>
      </main>
    </>
  );
}

export default Cart;
